<i18n>
{
	"en": {
		"generateOrders": "Generate Orders",
		"generate": "Generate",
		"cancel": "Cancel",
		"generateFrom": "Generate from",
		"selectedTemplates": "Selected templates",
		"allTemplates": "All templates",
		"timePeriod": "Time period",
		"from": "From",
		"to": "To",
		"autoScheduleFailed": "Could not generate orders",
		"autoScheduledOrders": "Orders were generated succsessfully"
	},
	"no": {
		"generateOrders": "Generer Truer",
		"generate": "Generer",
		"cancel": "Avbryt",
		"generateFrom": "Generer fra",
		"selectedTemplates": "Valgte maler",
		"allTemplates": "Alle maler",
		"timePeriod": "Periode",
		"from": "Fra",
		"to": "Til",
		"autoScheduleFailed": "Kunne ikke generere turer",
		"autoScheduledOrders": "Oppdrag ble generert"
	}
}
</i18n>

<template>
	<t-dialog
		:isShown="isShown"
		:title="$t('generateOrders')"
		:confirmLabel="$t('generate')"
		:cancelLabel="$t('cancel')"
		icon="add-to-artifact"
		iconType="bp"
		@close="onClose"
		@ok="generateOrders"
	>
		<div class="auto-schedule-dialog">
			<t-form-group :title="$t('generateFrom')" style="grid-column: 1/3;">
				<t-switch
					v-model="useSelectedTemplates"
					:checked="useSelectedTemplates"
					:disabled="!selectedTemplates.length"
					:label="$t('selectedTemplates')"
					:infoText="templateNames.length ? `(${templateNames})` : ''"
					:labelBefore="$t('allTemplates')"
					noColor
				/>
			</t-form-group>
			<t-form-group>
				<t-date-picker
					v-model="fromDate"
					:label="$t('from')"
					:dateFormat="displayDateFormat"
					:minDate="today"
					width="100%"
				/>
			</t-form-group>
			<t-form-group>
				<t-date-picker
					v-model="toDate"
					:label="$t('to')"
					:dateFormat="displayDateFormat"
					:minDate="toDateMinDate"
					width="100%"
				/>
			</t-form-group>
		</div>
	</t-dialog>
</template>

<script>
import { storageDateFormat, displayDateFormat } from '@/core';
import moment from 'moment';

import { autoScheduleRequest } from './requests';

export default {
	name: 'AutoScheduleDialog',
	props: {
		isShown: Boolean,
		selectedTemplates: Array
	},
	data() {
		return {
			useSelectedTemplates: false,
			startDate: '',
			endDate: ''
		};
	},
	computed: {
		fromDate: {
			get() {
				return this.startDate ? moment(this.startDate, storageDateFormat).startOf('d').format(displayDateFormat) : this.today.format(displayDateFormat);
			},
			set(displayDate) {
				this.startDate = moment(displayDate, displayDateFormat).format(storageDateFormat);
				if (this.endDate < this.startDate) {
					this.toDate = displayDate;
				}
			}
		},
		toDate: {
			get() {
				return this.endDate ? moment(this.endDate, storageDateFormat).startOf('d').format(displayDateFormat) : this.today.format(displayDateFormat);
			},
			set(displayDate) {
				this.endDate = moment(displayDate, displayDateFormat).format(storageDateFormat);
			}
		},
		displayDateFormat() {
			return displayDateFormat;
		},
		templateNames() {
			return this.selectedTemplates.map( (template) => template.name ).join(', ');
		},
		today() {
			return moment().startOf('d');
		},
		toDateMinDate() {
			return this.startDate ? moment(this.startDate, storageDateFormat) : this.today;
		},
		maxDate() {
			return this.today.add(14, 'd');
		}
	},
	watch: {
		isShown(newVal) {
			if (newVal) {
				this.useSelectedTemplates = Boolean(this.selectedTemplates.length);
				this.startDate = this.today.format(storageDateFormat);
				this.endDate = this.today.format(storageDateFormat);
			}
		}
	},
	methods: {
		onClose() {
			this.startDate = '';
			this.endDate = '';
			this.$emit('close');
		},
		async generateOrders() {
			try {
				await autoScheduleRequest({
					templateIds: this.useSelectedTemplates ? this.selectedTemplates.map( (template) => template.id ) : [],
					startDate: this.startDate,
					endDate: this.endDate
				});
				this.$notify({
					type: 'success',
					title: this.$t('autoScheduledOrders')
				});
				this.$emit('ok');
			} catch (e) {
				this.$notify({
					type: 'error',
					title: this.$t('autoScheduleFailed'),
					duration: -1
				});
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.auto-schedule-dialog {
	width: 100%;
	display: grid;
	grid-template-columns: repeat(2, minmax(1fr, max-content));
	row-gap: 20px;
	column-gap: 20px;
}

</style>